import { createFileRoute } from '@tanstack/react-router';
import { QuotesListPage } from '@/features/client/quotes/quote-list';
import { clientGuard } from '@/lib/route-guards';

export const Route = createFileRoute('/client/quotes/')({
  beforeLoad: clientGuard,
  component: QuotesListRoute,
});

function QuotesListRoute() {
  return <QuotesListPage />;
}
